import React from 'react';
import App from './../app.jsx';

import Home from './../pages/dashboard/Dashboard.jsx';
import Error from './../pages/error/error.js';
import Login from './../pages/auth/Login';
import { useSelector } from 'react-redux';

// El login ya deja una sesion valida (el token viene de un POST /auth/signin exitoso), asi
// que la navegacion se decide directo con isLogged: NO se vuelve a pegar a /auth/checksession
// aca. Antes se hacia ese round-trip extra apenas cambiaba isLogged, y si fallaba por
// cualquier motivo (incluyendo condiciones de carrera con otros dispatches), el interceptor
// global de Instance.js lo trataba como "sesion expirada" y deslogueaba la sesion recien
// creada, dejando al usuario viendo el toast de bienvenida sin poder entrar nunca. Si un
// token persistido/rehidratado ya no es valido, la primera llamada real a la API lo va a
// revelar con un 401 que el interceptor ya maneja.
const AppRoute = () => {
  const isLogged = useSelector(state => state.login.isLogged);

  return [
    {
      path: '*',
      element: <App />,
      children: [
        { path: '', element: isLogged ? <Home /> : <Login /> },
        { path: '*', element: <Error /> },
      ],
    },
  ];
};

export default AppRoute;
